import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UserService } from 'app/shared/services/user.service';
import { AuthenticationService } from 'app/shared/services/authentication.service';
import _ from 'lodash';
@Component({
  selector: 'successor',
  templateUrl: 'successor.html'
})

export class SuccessorComponent implements OnInit {
  @Output() valueChangeSuccessor = new EventEmitter();
  successorList = [];
  successorSelectedItems = [];
  successorSettings = {};
  is_allSuccesor: boolean;
  users: any = [];
  filter: any = {
    user_id: 'all',
  }
  constructor(

    public userService: UserService,
    public authService: AuthenticationService,
  ) { }
  ngOnInit() {
    this.successorList = [];
    this.successorSelectedItems = [];
    this.successorSettings = {
      singleSelection: false,
      text: 'Select Successor',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      searchPlaceholderText: 'Search',
      enableSearchFilter: true,
      badgeShowLimit: 5,
      groupBy: 'category'
    };
    this.getSuccessor();
  }
  getSuccessor() {
    const id = this.authService.user && this.authService.user.id
    this.userService.getSuccessor(id).subscribe(
      data => {
        this.users = data.users;
        const tempData = [];
        this.successorSelectedItems = [];
        _.forEach(this.users, function (value) {
          tempData.push({ 'id': value.id, 'itemName': value.first_name + ' ' + value.last_name, 'category': 'Successor' });
        })
        this.successorList = tempData;
      }
    )
  }
  getAllSuccessor() {
    this.userService.getAllSuccessor().subscribe(
      data => {
        this.users = data;
        const tempData = [];
        this.successorSelectedItems = [];
        _.forEach(this.users, function (parent) {
          _.forEach(parent.users, function (child) {
            tempData.push({ 'id': child.id, 'itemName': child.first_name + ' ' + child.last_name, 'category': parent.value })
          })
        });
        this.successorList = tempData;
      }, error => {

      })
  }
  onCheckboxChange() {
    // this.is_allSuccesor = !this.is_allSuccesor;
    console.log(this.is_allSuccesor);
    if (!this.is_allSuccesor) {
      this.getSuccessor();
    } else {
      this.getAllSuccessor();
    }
  }
  onItemSuccessorSelect(ev) {
    const tempData = [];
    _.forEach(this.successorSelectedItems, function (value) {
      tempData.push(value.id);
    })
    if (this.successorSelectedItems.length > 0) {
      this.filter.user_id = tempData;
    } else {
      this.filter.user_id = 'all';
    }
    this.valueChangeSuccessor.emit(this.filter);
  }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/components/successor/successor.ts